import { IntroTour } from 'ui-components';

export default IntroTour;
